import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export class HttpClient {
  private createAxios: AxiosInstance;

  constructor(baseURL: string) {
    this.createAxios = axios.create({
      baseURL,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Accept-Language': 'vi',
      },
      timeout: 10000,
    });
  }


  async get<T>(url: string, params?: any): Promise<AxiosResponse<T>> {
    return this.createAxios.get(url, {
      params,
      headers:{
        'Accept-Language': 'vi',
      }
    });
  }

  post<T>(url: string, data: any, config?: AxiosRequestConfig<any>): Promise<AxiosResponse<T>> {
    return this.createAxios.post(url, data, config);
  }
  put() { }

  patch<T>(url: string, data: any, config?: AxiosRequestConfig<any> | undefined): Promise<AxiosResponse<T>> {
    return this.createAxios.patch(url, data, config);
  }
  delete<T>(url: string, params?: any): Promise<AxiosResponse<T>> {
    return this.createAxios.delete(url, {
      params
    });
  }
}

export const httpClientCMS = new HttpClient(import.meta.env.VITE_API_CMS_URL + '/api')
export const httpClientProduct = new HttpClient(import.meta.env.VITE_API_BASE_URL + '/api')


